let decodedUri = decodeURI(location.href);
decodedUri = decodedUri.replaceAll(" ", "+");

const tagAll = "Усі";
const allTagsCount = document.getElementsByClassName('filter-news-items').length;

function getTags(uri) {
    if (uri.indexOf("tag") === -1 || uri.indexOf("tag") === uri.length - 4) {
        return [];
    }

    const tagsArray = uri.substring(uri.indexOf("tag") + 4).split("+");
    return tagsArray.filter(tag => tag !== tagAll);
}
const tag = getTags(decodedUri);


function updateURI(word) {
    const regex = RegExp('pageToGet=[0-9]+', 'g');
    const regexResult = regex.exec(decodedUri);
    if (regexResult) {
        const beginning = decodedUri.substring(0, regexResult.index - 1)
        decodedUri = beginning + "?tag=";
    }

    word = word.replaceAll(" ", "_");
    if (tag.includes(word)) {
        tag.splice(tag.indexOf(word), 1);
        if (tag.length == 0) {
            location.href = decodedUri.substring(0, decodedUri.indexOf("tag") - 1);
            return;
        }
    }
    else {
        tag.push(word);
    }
    if (decodedUri.indexOf("tag") == -1) {
        location.href = decodedUri + "?tag=" + word;
    }
    else {
        location.href = decodedUri.substring(0, decodedUri.indexOf("tag") + 4) + tag.join("+");
    }
}

$(document).ready(() => {
    const btnFilter = document.getElementById('filter-news-btn');
    const filterNewsFilter = document.querySelector('.filter-news-items');
    const headerTextElement = document.querySelector('.filter-news-header__text-second');

    const minDesktopWidth = 1160;

    btnFilter.addEventListener('click', () => {
        if (filterNewsFilter.classList.contains('display-hidden')) {
            filterNewsFilter.classList.remove('display-hidden');
            btnFilter.classList.add('filter-news-btn__opened');
        }
        else {
            filterNewsFilter.classList.add('display-hidden');
            btnFilter.classList.remove('filter-news-btn__opened');
        }
    });
    window.addEventListener('resize', setHeaderText);

});